// tslint:disable: curly
// tslint:disable: no-bitwise
export const lightenDarkenColor = (colorRgb: string, amt: number) => {
  const c = colorRgb.split(',');
  let col: string = rgbToHex([+c[0], +c[1], +c[2]]);
  let usePound = false;

  if (col[0] == '#') {
    col = col.slice(1);
    usePound = true;
  }

  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  [r, g, b] = [r, g, b].map((color) => (color <= 15 ? `0${color.toString(16)}` : color.toString(16))) as any;

  return (usePound ? '#' : '') + r + b + g;
};

function componentToHex(c) {
  const hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}

const rgbToHex = ([r, g, b]: [number, number, number]): string => {
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
};
